//
// scheduler-calendar-list-view-post.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/*global angular: false, console: false, _: false */

(function () {
    'use strict';

    var curalate = angular.module('curalate');

    curalate.directive('schedulerCalendarListViewPost', ['ProductTaggingService', 'SchedulerService', 'TrackingService', 'DateTimeService', 'SessionVarsService', 'UrlUtils', 'EnvironmentService', 'UniversalImageActionsHelpers', 'UniversalImageActionsItemType', 'UniversalImageActionsService',
        function(ProductTaggingService, SchedulerService, TrackingService, DateTimeService, SessionVarsService, UrlUtils, EnvironmentService, UniversalImageActionsHelpers, UniversalImageActionsItemType, UniversalImageActionsService) {
            return {
                restrict: 'E',
                replace: true,
                require: '^schedulerCalendarListView',
                scope: {
                    boards: '=',
                    buffers: '=',
                    hiddenBuffers: '=',
                    instagramDevices: '=',
                    network: '@',
                    post: '=ngModel',
                    postRemovedCallback: '&',
                    disabled: '&'
                },
                templateUrl: EnvironmentService.getTemplateRootDirectory() + 'scheduler/scheduler-calendar-list-view-post.html',
                controller: ['$rootScope', '$scope',
                    function($rootScope, $scope) {
                        var trackingCode, initSelectedBoardOrDevice, recomputeIsInPast;

                        // DO NOT CHANGE: Using 'BulkScheduler' for consistency with old tracking data.
                        trackingCode = TrackingService.CATEGORY_SCHEDULER;

                        $scope.state = {
                            isEditing: false,
                            isLoadingTags: true,
                            loadingTagsFailed: false,
                            outstandingAsyncAction: null,
                            postSnapshot: null,
                            selectedBoard: null,
                            selectedDevice: null,
                            tags: [],
                            brandPageV2Enabled: SessionVarsService.isFeatureEnabled('brand_page_v2'),
                            like2BuyEnabled: SessionVarsService.isFeatureEnabled('like2buy'),
                            isMobileTaggingEnabled: SessionVarsService.isFeatureEnabled('mobile_product_tagging'),
                            like2BuyMultiproductEnabled: SessionVarsService.isFeatureEnabled('like2buy_multiproduct'),
                            isUiaEnabled: SessionVarsService.isFeatureEnabled('universal_image_actions'),
                            failures: {
                                'authentication': 'Looks like your Pinterest credentials just need to be reset on the settings page!',
                                'board_authorization': 'You no longer have access to post to this board.',
                                'credentials': 'Looks like your Pinterest credentials just need to be reset on the settings page!',
                                'max_attempts': 'We encountered an error when attempting to pin this image. Please try again!',
                                'source_deleted': 'Uh oh...looks like the original pin no longer exists! Try repinning a different image.',
                                'noboard': 'Unfortunately, this board no longer exists. Try pinning to a live board instead!',
                                'small_image': 'Whoops, that image is too small to Pin! Try using an image 120x120 or larger.',
                                'large_image': 'Looks like this image is too large to pin. Try resizing the image and rescheduling.',
                                'broken_image': 'Holy moly, Pinterest says that image is broken! Try using a different image.',
                                'posted_broken_image': 'Hmmm, it looks like the Pin went through but the image is broken. Please verify on Pinterest directly.',
                                'writes_blocked': 'Pinterest has put your account in Safe Mode and is not allowing new pins. Please change your Pinterest password and reenter your new credentials on the settings page.',
                                'invalid_source': 'Pinterest does not allow pins using this domain. In general, they disallow click tracking links. Try scheduling the pin with a different source URL.',
                                'invalid_parameters': 'Pinterest says that one of the pin fields was invalid. Check that the url is valid and the description is less than 500 characters.',
                                'content': 'Pinterest thinks your source URL is spammy or inappropriate. Try a different URL.',
                                'push_notification': 'We failed to send a push notification to your mobile device. Try logging out of the Curalate mobile app and logging back in, then reschedule your post.',
                                'push_token': 'We failed to send a push notification to your mobile device. Try logging out of the Curalate mobile app and logging back in, then reschedule your post.',
                                'device': 'We failed to send a push notification to your mobile device. Try logging out of the Curalate mobile app and logging back in, then reschedule your post.',
                                'request_timeout': 'Pinterest never responded when we attempted to post the pin.  Please check that the pin does not already exist before retrying.'
                            }
                        };

                        $scope.networkBuffers = [];

                        // When a new post is scheduled, the scheduler form stashes the tags in a 'tagsFromScheduler'
                        // property that we use here to avoid re-fetching tags.  Without this, the momentary lapse
                        // of data while the async request is happening can cause users to think their tags weren't added.
                        if ($scope.post.tagsFromScheduler) {
                            $scope.state.tags = $scope.post.tagsFromScheduler;
                            $scope.state.isLoadingTags = false;
                        }

                        initSelectedBoardOrDevice = function() {
                            if ($scope.post.pinterestOptions) {
                                $scope.state.selectedBoard = _.find($scope.boards, function(b) { return b.id === $scope.post.pinterestOptions.boardId; });
                                $scope.state.selectedDevice = null;
                            }

                            if ($scope.post.instagramOptions) {
                                $scope.state.selectedDevice = _.find($scope.instagramDevices, function(d) { return d.id === $scope.post.instagramOptions.mobileDeviceId; });
                                $scope.state.selectedBoard = null;
                            }
                        };

                        recomputeIsInPast = function() {
                            $scope.post.isInPast = !$scope.post.isUnscheduled() && DateTimeService.userMoment($scope.post.scheduleDateTime).isBefore(DateTimeService.userNow());
                        };

                        //
                        // Scope functions
                        //
                        $scope.post.bufferNetwork = function() {
                            var buffer = _.findWhere($scope.buffers, { id: parseInt($scope.post.bufferId, 10) });
                            return buffer.network;
                        };

                        $scope.post.isUnscheduled = function() {
                            var buffer = _.findWhere($scope.buffers, { id: parseInt($scope.post.bufferId, 10) });
                            return (!buffer.active && ($scope.post.scheduleType === 'auto') &&
                                (($scope.post.status === 'pending') || ($scope.post.status === 'scheduled')));
                        };

                        $scope.post.isNotified = function() {
                            return ($scope.post.status === 'notified');
                        };

                        $scope.post.isUnscheduledOrNotified = function() {
                            return $scope.post.isUnscheduled() ||  $scope.post.isNotified();
                        };

                        $scope.post.isUnscheduledWithDate = function() {
                            return $scope.post.isUnscheduled() && ($scope.post.scheduleDateTime != null);
                        };

                        $scope.post.isUnscheduledWithoutDate = function() {
                            return $scope.post.isUnscheduled() && ($scope.post.scheduleDateTime == null);
                        };

                        $scope.post.formatTime = function() {
                            return DateTimeService.formatUserMoment($scope.post.scheduleDateTime, 'h:mm');
                        };

                        $scope.post.formatDate = function() {
                            return DateTimeService.formatUserMoment($scope.post.scheduleDateTime, 'MMMM Do, YYYY');
                        };

                        $scope.post.formatTimeAmPm = function() {
                            return DateTimeService.formatUserMoment($scope.post.scheduleDateTime, 'A');
                        };

                        $scope.post.editClicked = function() {
                            var postItemType;
                            $scope.state.postSnapshot = angular.copy($scope.post);
                            $scope.state.isEditing = true;

                            if ($scope.post.status === 'failed') {
                                $scope.post.scheduleDateTime = DateTimeService.roundNow().add('h', 1);
                            }

                            if ($scope.post.bufferNetwork() === "Instagram") {
                                postItemType = UniversalImageActionsItemType.schedulerInstagram;
                            } else if ($scope.post.bufferNetwork() === "Pinterest") {
                                postItemType = UniversalImageActionsItemType.schedulerPinterest;
                            }

                            $scope.universalItemId = UniversalImageActionsHelpers.itemIdToUniversalItemId(
                                postItemType,
                                $scope.post.id
                            );

                            UniversalImageActionsService.getItemMetadataAsync($scope.universalItemId, /*params*/ null, /*forceRefresh*/ true).then(function(response) {
                                ProductTaggingService.setProducts(response.productTags, $scope.universalItemId);
                                $scope.post.products = angular.copy(ProductTaggingService.getProducts());
                            });
                        };

                        $scope.post.cancelClicked = function() {
                            // If UIA is enabled, products are not affected by the cancel button
                            if ($scope.state.isUiaEnabled) {
                                $scope.state.postSnapshot.products = $scope.post.products;
                            }

                            $scope.post = $scope.state.postSnapshot;
                            $scope.post.submitError = null;
                            $scope.post.submitted = false;
                            $scope.state.postSnapshot = null;
                            $scope.state.isEditing = false;

                            // Resets selected board or device to truth in case they've been changed during editing.
                            initSelectedBoardOrDevice();
                        };

                        $scope.post.deleteClicked = function() {
                            TrackingService.recordEvent(trackingCode, 'DeleteScheduledItem');

                            $scope.post.submitError = null;
                            $scope.state.outstandingAsyncAction = 'delete';
                            SchedulerService.removeScheduleAsync($scope.post.bufferId, $scope.post.id).
                                then(function() {
                                    $scope.postRemovedCallback({
                                        id: $scope.post.id
                                    });
                                }).catch(function(error) {
                                    $scope.post.submitError = error;
                                }).
                                finally(function() {
                                    $scope.state.outstandingAsyncAction = null;
                                });
                        };

                        $scope.post.copyClicked = function() {
                            var post = $scope.post,
                                source;

                            if (post.pinterestOptions) {
                                source = post.pinterestOptions.destinationUrl;
                            }

                            $scope.state.outstandingAsyncAction = 'copyingImage';

                            SchedulerService.addSavedImageUrlAsync(post.imageUrl, source, post.description, null /*productsList*/, null /*universalItemId*/, post.videoId).then(function(response) {
                                response.tags = angular.copy($scope.state.tags);
                                response.bufferId = post.bufferId;
                                $rootScope.$emit('appendSavedImageToScheduler', response);
                            }).finally(function() {
                                $scope.state.outstandingAsyncAction = null;
                            });
                        };

                        $scope.post.postNowClicked = function(suppressInstagramPostNotification) {
                            $scope.post.postNow = true;
                            $scope.post.suppressInstagramPostNotification = suppressInstagramPostNotification;
                            $scope.post.saveClicked();
                        };

                        $scope.post.saveClicked = function(postForm) {
                            var productUpdateArgs, promise, chainedPromiseResult, itemUpdateArgs, device, board, isRescheduling,
                                SCHEDULE_TYPE_POST_NOW, form;

                            // Constants from SchedulePin.scala
                            SCHEDULE_TYPE_POST_NOW = 'now';

                            $scope.post.submitError = null;
                            $scope.post.submitted = true;
                            form = postForm;

                            if (!form || form.$valid) {
                                promise = null;
                                chainedPromiseResult = null;

                                if (typeof $scope.post.bufferId === 'string') {
                                    $scope.post.bufferName = _.findWhere($scope.buffers, { id: parseInt($scope.post.bufferId, 10) }).name;
                                    $scope.post.bufferId = parseInt($scope.post.bufferId, 10);
                                }

                                if ($scope.post.postNow) {
                                    $scope.post.scheduleType = SCHEDULE_TYPE_POST_NOW;
                                }
                                // Update the Device or Board name, since <select/> elements can't.
                                if ($scope.state.postSnapshot !== null) {
                                    if ($scope.post.bufferNetwork() === 'Instagram') {
                                        device = _.findWhere($scope.instagramDevices, { id: $scope.state.selectedDevice.id });
                                        $scope.post.instagramOptions.mobileDeviceId = device.id;
                                        $scope.post.instagramOptions.mobileDeviceName = device.name;
                                    } else if ($scope.post.bufferNetwork() === 'Pinterest') {
                                        board = _.findWhere($scope.boards, { id: $scope.state.selectedBoard.id });
                                        $scope.post.pinterestOptions.boardId = board.id;
                                        $scope.post.pinterestOptions.boardName = board.name;
                                    }
                                }

                                // ensure that the scheduleDateTime is in the format that the server expects (i.e. with milliseconds)
                                $scope.post.scheduleDateTime = DateTimeService.formatUserMoment($scope.post.scheduleDateTime);

                                // TODO: Remove this once everything is switched over to the products list.
                                if ($scope.post.instagramOptions) {
                                    $scope.post.instagramOptions.like2BuyUrl = UrlUtils.cleanUrl($scope.post.instagramOptions.like2BuyUrl);
                                }

                                itemUpdateArgs = {
                                    bufferItem: $scope.post,
                                    suppressInstagramPostNotification: $scope.post.suppressInstagramPostNotification,
                                    tags: $scope.state.tags
                                };

                                TrackingService.recordEvent(trackingCode,
                                                            'UpdateSchedule',
                                                            'Schedule=' + $scope.post.scheduleType + ',Network=' + $scope.post.bufferNetwork() + ($scope.post.videoId ? ',video' : ''));
                                if ($scope.state.tags.length > 0) {
                                    TrackingService.recordEvent(trackingCode, 'BrandTags', 'Count=' + $scope.state.tags.length, $scope.state.tags.length);
                                }

                                isRescheduling = $scope.post.status === 'failed';
                                $scope.state.outstandingAsyncAction = 'update';

                                // Make a request to update the buffer item.
                                promise = SchedulerService.updateScheduleAsync($scope.post.bufferId, $scope.post.id, itemUpdateArgs);

                                /**
                                 * This logic was used to support Like2Buy v1's destination_url. The Dashboard has been
                                 * updated at this point to support multiproduct-tagging and has special logic for the
                                 * "exactly 1 product" case, but mobile still uses a destination_url field. As soon as
                                 * all clients have upgraded to "mobile_product_tagging" this code block can all be removed.
                                 */
                                if (!$scope.state.isMobileTaggingEnabled && $scope.state.like2BuyMultiproductEnabled && $scope.post.bufferNetwork() === 'Instagram') {
                                    // Adding a product URL to an existing item when multiproduct is enabled.
                                    if ($scope.post.legacyProductUrl && $scope.post.products.length === 0) {
                                        $scope.post.products = [{
                                            destinationUrl: UrlUtils.cleanUrl($scope.post.legacyProductUrl),
                                            position: 1
                                        }];
                                    }

                                    // User deleted the text from the only existing product URL, this is taken as an implicit deletion of the product.
                                    if ($scope.post.products.length === 1 && !$scope.post.products[0].destinationUrl) {
                                        // Empty out the list so the backend knows to delete the product.
                                        $scope.post.products = [];
                                    }

                                    // Handles all other updates to products including the no-op case.
                                    productUpdateArgs = {
                                        products: $scope.post.products
                                    };

                                    // Make a request to update the products list associated with the buffer item.
                                    promise = promise.then(function(response) {

                                        // We need to save the result from the updateScheduleAsync call so we can use it after the promise from
                                        // updateBufferItemProductsAsync completes. Updating products and the buffer item should be atomic.
                                        // TODO: Factor out this promise chaining when DEV-7427 is complete which adds 'products' as a data
                                        // parameter for updateScheduleAsync.
                                        chainedPromiseResult = response;

                                        // We chain the promises this way so that errors from updateScheduleAsync and updateBufferItemProductsAsync
                                        // are both handled by the sole catch and finally statements.
                                        return SchedulerService.updateBufferItemProductsAsync($scope.post.bufferId, $scope.post.id, productUpdateArgs);
                                    });
                                }

                                promise.then(function(response) {

                                    var scheduleResponse;

                                    if (chainedPromiseResult) {
                                        // Chained result from updateScheduleAsync.
                                        scheduleResponse = chainedPromiseResult;

                                        // Get the updated products list from updateBufferItemProductsAsync.
                                        scheduleResponse.products = response.products;

                                        // Sync instagramOptions.like2BuyUrl with the products list.
                                        if (response.products.length > 0) {
                                            scheduleResponse.instagramOptions.like2BuyUrl = response.products[0].destinationUrl;
                                        } else {
                                            scheduleResponse.instagramOptions.like2BuyUrl = null;
                                        }

                                        // Clear out the legacy product url or this will show again if the text is deleted and the product is updated.
                                        $scope.post.legacyProductUrl = "";

                                    } else {
                                        scheduleResponse = response;
                                    }

                                    $scope.post.products = scheduleResponse.products;
                                    $scope.post.instagramOptions = scheduleResponse.instagramOptions;

                                    if (isRescheduling) {
                                        // Store the updated products.
                                        $rootScope.$emit('postScheduled', scheduleResponse);
                                    } else {
                                        $rootScope.$emit('postUpdated', $scope.post);
                                        $scope.state.postSnapshot = null;
                                        $scope.state.isEditing = false;
                                    }

                                    if ($scope.post.postNow || isRescheduling) {
                                        $scope.postRemovedCallback({
                                            id: $scope.post.id
                                        });
                                    }

                                    $scope.post.submitted = false;
                                }).catch(function(error) {
                                    $scope.post.submitError = error;
                                }).finally(function() {
                                    $scope.state.outstandingAsyncAction = null;
                                });
                            }
                        };

                        $scope.$on('uia:modal:closed', function($event, response) {
                            if (response.productsChanged && (response.universalItemId.indexOf($scope.post.id) > -1) && (response.universalItemId.indexOf("scheduler") > -1)) {
                                $scope.post.products = response.products;
                            }
                        });

                        $scope.post.scheduleDateTimeChanged = function(dateTime) {
                            $scope.post.scheduleDateTime = dateTime;
                            if ($scope.post.scheduleType === 'auto') {
                                $scope.post.scheduleType = 'manual';
                            }
                            recomputeIsInPast();
                        };

                        $scope.post.isDisabledOrOutstandingAction = function() {
                            return $scope.disabled() || $scope.state.outstandingAsyncAction !== null;
                        };

                        $scope.post.isDisabled = function() {
                            return $scope.post.isDisabledOrOutstandingAction() ||
                                ($scope.post.isInPast && ($scope.post.status !== 'failed'));
                        };

                        $scope.post.getFailureReason = function() {
                            return $scope.state.failures[$scope.post.failureReason];
                        };

                        // TODO: Move this up to top of file
                        $scope.post.like2BuyEnabled = SessionVarsService.isFeatureEnabled('like2buy');

                        // Perform this filtering with a $watch to avoid an infdig error
                        $scope.$watch('buffers', function() {
                            $scope.networkBuffers = _.where($scope.buffers, { network: $scope.post.bufferNetwork() });
                        });

                        /**
                         * Mobile-specific code for product tagging.
                         *
                         * When we "come back" from the productize view, update this item's products.
                         */
                        $scope.$on('$stateChangeSuccess', function() {
                            $scope.post.products = angular.copy(ProductTaggingService.getProducts());
                        });

                        // END - Mobile specific code.

                        // Initialize the rest of the post data
                        recomputeIsInPast();

                        initSelectedBoardOrDevice();

                        // Only fetch tags if they haven't been passed to us directly from the scheduler.
                        if (!$scope.post.tagsFromScheduler) {
                            SchedulerService.getTagsForImageAsync($scope.post.fileId).
                                then(function(response) {
                                    $scope.state.isLoadingTags = false;
                                    $scope.state.tags = response.tags;
                                }).
                                catch(function() {
                                    $scope.state.loadingTagsFailed = true;
                                }).
                                finally(function() {
                                    $scope.state.isLoadingTags = false;
                                });
                        }
                    }
                ]
            };
    }]);

})();
